const COPYABLE_FIELD_KINDS = [
  {
    pattern: /(?:^|\b)(?:monto|importe|capital|inter[eé]s(?:es)?|honorarios?|remuneraci[oó]n|salario|sueldo|total\s+(?:actualizado|a\s+pagar)|suma\s+de\s+pesos)(?:\b|$)/i,
    label: "importe",
    copiedMessage: "Importe copiado",
    copyFormat: "money",
  },
  {
    pattern: /(?:^|\b)(?:cuit|cuil|tax[\s_-]*id)(?:\b|$)/i,
    label: "CUIT",
    copiedMessage: "CUIT copiado",
  },
  {
    pattern: /(?:^|\b)(?:dni|documento[\s_-]*(?:n[uú]mero|nro|num)|document[\s_-]*number)(?:\b|$)/i,
    label: "DNI",
    copiedMessage: "DNI copiado",
  },
  {
    pattern: /(?:^|\b)(?:matr[ií]cula|registration)(?:\b|$)/i,
    label: "matrícula",
    copiedMessage: "Matrícula copiada",
  },
  {
    pattern: /(?:^|\b)(?:tel[eé]fono|tel|phone|celular|m[oó]vil|whatsapp)(?:\b|$)/i,
    label: "teléfono",
    copiedMessage: "Teléfono copiado",
  },
  {
    pattern: /(?:^|\b)(?:domicilio|direcci[oó]n|address|provincia|departamento|localidad|barrio|calle|piso|oficina|dpto|c[oó]digo\s+postal)(?:\b|$)/i,
    label: "domicilio",
    copiedMessage: "Domicilio copiado",
  },
];

export function copyableFieldMetadata(field) {
  const searchable = [
    field?.label,
    field?.key,
    field?.range?.groupLabel,
    field?.range?.columnLabel,
    field?.block?.groupLabel,
    field?.block?.attributeLabel,
  ].filter(Boolean).join(" ").replace(/[_./:-]+/g, " ");
  if (field?.type === "currency") {
    return {
      label: "importe",
      copiedMessage: "Importe copiado",
      copyFormat: "money",
    };
  }
  if (/\bdni\b/i.test(searchable) && /\b(?:cuit|cuil)\b/i.test(searchable)) {
    return {
      label: "documento",
      copiedMessage: "Documento copiado",
    };
  }
  return COPYABLE_FIELD_KINDS.find(({ pattern }) => pattern.test(searchable)) || null;
}
